export default __webpack_public_path__ + "./images/de.735824d6.png";